import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "ride"
const RideIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 7.3h-7.8L6.8 12v2.3h1.6c0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3h4.7c0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3H24V12c0-.9-.7-1.6-1.6-1.6h-1.6l-2.3-3.1Zm-7.4 1.2h3.1v2H9.5l1.6-2Zm4.3 0h2.7l1.5 2h-4.3v-2h.1Zm-4.7 4.7c.6 0 1.2.5 1.2 1.2 0 .6-.5 1.2-1.2 1.2s-1.2-.6-1.2-1.3c0-.6.6-1.1 1.2-1.1Zm9.4 0c.6 0 1.2.5 1.2 1.2 0 .6-.5 1.2-1.2 1.2-.6 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2ZM7.5 8.7h-3c-.3 0-.6-.3-.6-.7 0-.4.3-.6.6-.6h2.9c.4 0 .6.3.6.6.1.4-.2.7-.5.7Zm-2.6 5.1h-3c-.4 0-.6-.3-.6-.6 0-.4.3-.6.6-.6h2.9c.4 0 .6.3.6.6.1.3-.2.6-.5.6ZM6 11.1H.6c-.4 0-.6-.3-.6-.6s.3-.6.6-.6H6c.4 0 .6.3.6.6s-.2.6-.6.6Z"
      />
    </svg>
  )
}
export default RideIcon
